export const environment = {
    production: true,
    api: 'https://feature41206.api.classichub.co.nz',
    buildVersion: '2026.2.5.6',
    uri: 'https://feature41206.classichub.co.nz',
    envName: 'feature41206',
    isTest: true,
};

